exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Label-module__label___JviOK{width:-moz-fit-content;width:fit-content;border-radius:22px;text-transform:uppercase;display:flex;align-items:center;justify-content:center;white-space:nowrap}.Label-module__label___JviOK.Label-module__blue___36YHZ{background-color:#0827e9;color:#fff}.Label-module__label___JviOK.Label-module__white___62QQB{background-color:hsla(0,0%,100%,.25);color:#fff}.Label-module__label___JviOK.Label-module__grey___2l_Dy{background-color:#ececec;color:#0827e9}.Label-module__label___JviOK.Label-module__outline___2WfeX{border:2px solid #0827e9;color:#0827e9}.Label-module__label___JviOK.Label-module__small___2UpXp{font-size:10px;height:17px;padding:1px .5rem 0}.Label-module__label___JviOK.Label-module__large___14UBs{font-size:12px;height:23px;padding:2px 1rem 0}.Label-module__label-wrapper___2Syqf{display:flex;flex-wrap:wrap}.Label-module__label-wrapper___2Syqf>*{margin:.5rem .5rem 0 0}", ""]);

// exports
exports.locals = {
	"label": "Label-module__label___JviOK",
	"blue": "Label-module__blue___36YHZ",
	"white": "Label-module__white___62QQB",
	"grey": "Label-module__grey___2l_Dy",
	"outline": "Label-module__outline___2WfeX",
	"small": "Label-module__small___2UpXp",
	"large": "Label-module__large___14UBs",
	"label-wrapper": "Label-module__label-wrapper___2Syqf"
};